import { render, staticRenderFns } from "./ChipInput.vue?vue&type=template&id=8424ad0e&scoped=true&"
import script from "./ChipInput.vue?vue&type=script&lang=js&"
export * from "./ChipInput.vue?vue&type=script&lang=js&"
import style0 from "./ChipInput.vue?vue&type=style&index=0&id=8424ad0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8424ad0e",
  null
  
)

export default component.exports